function OnsiteSiteVisitTablePager() {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            currentPage: "=",
            itemsPerPage: "=",
            pageChangeCallback: "=?",
            totalItems: "="
        },
		template: require('./site-visit-table-pager.html'),

        link: function (scope) {

            function onTotalItemsChanged(itemCount){
                var baseNum = Math.ceil(itemCount / scope.itemsPerPage);

                scope.pageNumbers = [];

                for(var i = 0; i < baseNum; i++){
                    scope.pageNumbers.push(i);
                }
            }

            scope.setCurrentPage = function(pageNumber){
                if(scope.pageChangeCallback instanceof Function){
                    scope.pageChangeCallback(pageNumber);
                }
            };

            (function(){
                scope.pageNumbers = [];
                scope.$watch('totalItems', onTotalItemsChanged);
                onTotalItemsChanged(scope.totalItems);
            })();
        }
    }
}

angular.module('onsite').directive('onsiteSiteVisitTablePager', [OnsiteSiteVisitTablePager]);
